import { Reveal } from "@/components/site/Reveal";
import { IMAGES } from "@/site";
import { HeartHandshake, Activity, Accessibility, ShieldCheck } from "lucide-react";

const POINTS = [
  { icon: Activity, title: "Stroke recovery", desc: "Patient, progressive rebuilding of strength, balance and confidence." },
  { icon: Accessibility, title: "Mobility & disabilities", desc: "Adapted movement for a range of physical needs and abilities." },
  { icon: HeartHandshake, title: "80+ & elderly", desc: "Gentle strength work for healthy bones, muscles and independence." },
  { icon: ShieldCheck, title: "Rare conditions", desc: "Careful, informed support — including conditions such as prion disease." },
];

export const Inclusive = () => (
  <section id="inclusive" className="py-24 md:py-32 bg-[#0F172A]">
    <div className="mx-auto max-w-7xl px-5 md:px-10 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
      <Reveal className="order-2 lg:order-1">
        <span className="font-mono-label text-[11px] text-[#FACC15]">Training for everyone</span>
        <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl mt-4">
          The greatest <span className="text-[#FACC15]">challenge</span>, the biggest reward.
        </h2>
        <p className="text-[#94A3B8] mt-5 text-base md:text-lg leading-relaxed max-w-xl">
          Some of my most meaningful work is with people others might turn away. If you have a
          condition, an injury, or simply feel that fitness "isn't for you" — it can be, and I'll
          meet you exactly where you are.
        </p>
        <div className="grid sm:grid-cols-2 gap-5 mt-10">
          {POINTS.map((p, i) => {
            const Icon = p.icon;
            return (
              <Reveal key={i} delay={i * 0.07}>
                <div
                  data-testid={`inclusive-point-${i}`}
                  className="p-5 rounded-2xl border border-white/10 bg-[#020617]/40 h-full hover-lift hover:-translate-y-1"
                >
                  <Icon size={22} className="text-[#FACC15]" />
                  <h3 className="font-display text-xl mt-3">{p.title}</h3>
                  <p className="text-[#94A3B8] text-sm mt-1.5 leading-relaxed">{p.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </Reveal>

      <Reveal delay={0.1} className="order-1 lg:order-2">
        <div className="relative rounded-[2.5rem] overflow-hidden border border-white/10 h-80 md:h-[560px] group">
          <img src={IMAGES.inclusive} alt="Supportive one-to-one rehabilitation training" className="img-desat w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#020617]/70 to-transparent" />
          <div className="absolute bottom-6 left-6 right-6 glass rounded-2xl p-5 border border-white/10">
            <p className="font-display text-lg text-[#FACC15]">Willing to put the work in?</p>
            <p className="text-[#94A3B8] text-sm mt-1">Then I'll find the best way — and the best price — for both of us.</p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
